function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.703 4.095l-6.174 3.43c-1.298.721-1.298 2.587 0 3.308l6.174 3.43a4.733 4.733 0 004.594 0l6.174-3.43c1.298-.721 1.298-2.587 0-3.308l-6.174-3.43a4.733 4.733 0 00-4.594 0z",
  stroke: "currentColor",
  strokeWidth: "1.419",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.991 12.2v3.924c0 .949.475 1.834 1.264 2.359l1.607 1.069a5.666 5.666 0 006.275 0l1.607-1.069a2.832 2.832 0 001.264-2.359V12.2",
  stroke: "currentColor",
  strokeWidth: "1.417",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));